<h3 class="card-header text-center">
    <div class="row center">
        <!-- <div class="col offset-md-1"> -->
        <img src="../assets/logo.png" class="d-inline-block ml-3" style="width: 50%;">
        <!-- </div> -->
        <!-- <div class="col"> -->
        <!-- </div> -->
    </div>
</h3>
<div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
            <i class="glyphicon glyphicon-user"></i>
            <input type="text" formControlName="email" class="form-control field" placeholder="{{ 'LOGIN_EMAIL' | translate }}" 
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">Email is invalid</div>
            </div>
        </div>
        <div class="form-group">

            <input type="password" formControlName="password" class="form-control field" placeholder="{{'LOGIN_PASSWORD' | translate}}"
                [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
        </div>
        <div class="form-group">
            <button [disabled]="loading" class="btn btn-primary form-control btn-block field">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                {{'LOGIN'|translate}}
            </button>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <a routerLink="../register" class="btn btn-link">{{'LOGIN_REGISTER'|translate}}</a>
            </div>
            <div class="form-group col text-right">
                <a routerLink="../forgot-password" class="btn btn-link pr-0">{{'LOGIN_FORGET'|translate}}</a>
            </div>
        </div>
    </form>
</div>